import { defineComponent } from 'vue'

import { reactiveVueMixin } from '@skinsoft/reactive-vue'

export interface SoloItemEditScreenRoutes {
    onlineRoute: string,
    offlineRoute: string
}

export const SoloItemEditScreen = defineComponent({
    mixins: [reactiveVueMixin],
    props: ['itemId', 'itemEditScreen', 'routes', 'headerTitle'],
    template: require('./solo-item-edit-screen.html'),
    data() {
        return {
            isOnline: window.navigator.onLine,
        }
    },
    mounted() {
        window.addEventListener('online', this.updateConnexionStatus)
        window.addEventListener('offline', this.updateConnexionStatus)
    },
    beforeUnmount() {
        window.removeEventListener('online', this.updateConnexionStatus)
        window.removeEventListener('offline', this.updateConnexionStatus)
    },
    computed: {
        navigateBackRoute(): string {
            return this.isOnline ? this.routes.onlineRoute : this.routes.offlineRoute
        },
    },
    methods: {
        updateConnexionStatus() {
            this.isOnline = window.navigator.onLine
        },
    },
})
